$(document).on('change', 'input[type="file"][data-trigger="preview"]', function(e) {
	var file = e.target.files[0],
		fileReader = new FileReader(),
		trigger = this;
	fileReader.onload = function(event) {
		$($(trigger).data('target')).attr('src', event.target.result);
	}
	fileReader.readAsDataURL(file);
})